import { useEffect, useState } from "react";
import UploadDropzone from "./UploadDropzone";
import { getUserInfo, updateUserInfo } from "api/User";
import { getProvinces, getDistricts, getWards } from "api/LocationInfo";
import { toast } from "react-toastify";

export default function Infomation() {
    const [user, setUser] = useState<any>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [businessType, setBusinessType] = useState("business");
    const [loading, setLoading] = useState(false);

    // Location state
    const [provinces, setProvinces] = useState<any[]>([]);
    // const [districts, setDistricts] = useState<any[]>([]);
    const [wards, setWards] = useState<any[]>([]);

    const [selectedProvince, setSelectedProvince] = useState<string>("");
    // const [selectedDistrict, setSelectedDistrict] = useState<string>("");
    const [selectedWard, setSelectedWard] = useState<string>("");
    const [businessAddress, setBusinessAddress] = useState<string>("");
    const [businessName, setBusinessName] = useState<string>("");

    useEffect(() => {
        const fetchInitialData = async () => {
            const [userData, provinceData] = await Promise.all([
                getUserInfo().then(data => data.info || null),
                getProvinces()
            ]);

            setProvinces(provinceData);

            if (userData) {
                setUser(userData);
                if (userData.business_type) setBusinessType(userData.business_type);
                if (userData.business_name) setBusinessName(userData.business_name);
                if (userData.business_province) setSelectedProvince(userData.business_province);
                // if (userData.business_district) setSelectedDistrict(userData.business_district);
                if (userData.business_ward) setSelectedWard(userData.business_ward);
                if (userData.business_address) setBusinessAddress(userData.business_address);
            }
        };
        fetchInitialData();
    }, []);

    // Load districts when province changes
    // useEffect(() => {
    //     if (!selectedProvince) {
    //         setDistricts([]);
    //         return;
    //     }
    //     const province = provinces.find(p => p.name === selectedProvince);
    //     if (province) {
    //         getDistricts(province.id).then(setDistricts);
    //     }
    // }, [selectedProvince, provinces]);

    // Load wards when district changes
    useEffect(() => {
        if (!selectedProvince) {
            setWards([]);
            return;
        }
        const province = provinces.find(p => p.name === selectedProvince);
        if (province) {
            getWards(province.code).then(setWards);
        }
    }, [selectedProvince, provinces]);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await updateUserInfo({
                business_type: businessType,
                business_name: businessName,
                business_image: selectedFile || undefined,
                business_province: selectedProvince,
                // business_district: selectedDistrict,
                business_ward: selectedWard,
                business_address: businessAddress
            });
            toast.success("Cập nhật thông tin thành công.", {
                position: "bottom-right",
            });
            const data = await getUserInfo();
            if (data) setUser(data);
        } catch (error) {
            console.error(error);
            toast.error("Cập nhật thông tin thất bại. Vui lòng thử lại.", {
                position: "bottom-right",
            });
        } finally {
            setLoading(false);
        }
    };

    if (!user) return null;

    return (
        <div
            className="MuiTabPanel-root styles_tab_panel__NZzZm"
            role="tabpanel"
            aria-labelledby="mui-p-85509-T-3"
            id="mui-p-85509-P-3"
        >
            <div className="jss60">
                <div className="MuiBox-root css-0" style={{ width: "100%" }}>
                    <div className="MuiBox-root css-0">
                        <div
                            className="MuiGrid-root MuiGrid-container MuiGrid-justify-content-xs-center"
                            style={{ width: "100%" }}
                        >
                            <div className="MuiFormControl-root MuiTextField-root jss22">
                                <label
                                    className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled Mui-disabled Mui-disabled MuiFormLabel-filled"
                                    data-shrink="true"
                                    htmlFor="type"
                                    id="type-label"
                                >
                                    Bạn là
                                </label>
                                <div className="MuiInputBase-root MuiFilledInput-root jss66 Mui-disabled Mui-disabled MuiInputBase-formControl">
                                    <input
                                        aria-invalid="false"
                                        id="type"
                                        type="text"
                                        className="MuiInputBase-input MuiFilledInput-input Mui-disabled Mui-disabled"
                                        value={user.customer_type_name || "Quầy thuốc"}

                                    />
                                </div>
                            </div>

                            <div className="MuiFormControl-root MuiTextField-root jss22">
                                <label
                                    className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                    data-shrink="true"
                                    htmlFor="business_name"
                                    id="business_name-label"
                                >
                                    Tên Quầy thuốc / Công ty
                                    <span
                                        aria-hidden="true"
                                        className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                    >
                                        &thinsp;*
                                    </span>
                                </label>
                                <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                    <input
                                        aria-invalid="false"
                                        id="business_name"
                                        type="text"
                                        className="MuiInputBase-input MuiFilledInput-input"
                                        value={businessName}
                                        onChange={(e) => setBusinessName(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            <div
                                className="MuiBox-root css-0 ctrl-w-80-991-100"
                                style={{
                                    borderRadius: "8px",
                                    border: "1px solid rgb(226, 226, 225)",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <div className="MuiFormControl-root MuiTextField-root jss22 styles_w_90__eXdxb">
                                    <label
                                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled"
                                        data-shrink="true"
                                        htmlFor="id1"
                                        id="id1-label"
                                    >
                                        Bấm vào để chọn loại giấy tờ
                                    </label>
                                    <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                        <select
                                            className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input"
                                            aria-invalid="false"
                                            id="id1"
                                            value={businessType}
                                            onChange={(e) => setBusinessType(e.target.value)}
                                        >
                                            <option value="business">Giấy phép kinh doanh</option>
                                            <option value="gpp">Hồ sơ GPP</option>
                                            <option value="pharmacyEligibility">
                                                Giấy chứng nhận đủ điều kiện kinh doanh dược
                                            </option>
                                        </select>
                                        <svg
                                            className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled"
                                            focusable="false"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path d="M7 10l5 5 5-5z" />
                                        </svg>
                                    </div>
                                </div>

                                <div className="style_wrap__D9Ian style_w_90__DH_cU">
                                    <p
                                        className="MuiTypography-root MuiTypography-body1"
                                        style={{
                                            textAlign: "start",
                                            fontSize: "16px",
                                            color: "rgb(134, 133, 133)",
                                            marginBottom: "10px",
                                        }}
                                    />

                                    <div
                                        className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-justify-content-xs-center"
                                        style={{ marginTop: "10px" }}
                                    />

                                    <section>
                                        {!selectedFile && user.business_image && (
                                            <div style={{ marginBottom: "15px" }}>
                                                <p style={{ fontSize: "14px", color: "rgb(134, 133, 133)", marginBottom: "8px" }}>Ảnh hiện tại:</p>
                                                <div style={{ position: "relative", width: "120px", height: "120px" }}>
                                                    <img
                                                        src={user.business_image}
                                                        alt="Business Document"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid rgb(226, 226, 225)"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <UploadDropzone onFilesChange={(files) => setSelectedFile(files[0] || null)} />
                                    </section>
                                </div>
                            </div>

                            <div
                                className="MuiBox-root css-0"
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    width: "100%",
                                    marginTop: "15px",
                                }}
                            >
                                <p
                                    className="MuiTypography-root MuiTypography-body1 lg:pl-[90px] pl-[0px]"
                                    style={{
                                        textTransform: "capitalize",
                                        fontSize: "16px",
                                        fontFamily: "ggsm",
                                    }}
                                >
                                    Nhập thông tin địa chỉ Quầy thuốc
                                </p>
                            </div>

                            <div className="styles_full_width_center__WpE9Z" style={{ margin: "auto" }}>
                                <div className="MuiFormControl-root MuiTextField-root jss22">
                                    <label
                                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                        data-shrink="true"
                                        htmlFor="92"
                                        id="92-label"
                                    >
                                        Tỉnh/Thành phố
                                        <span
                                            aria-hidden="true"
                                            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                        >
                                            &thinsp;*
                                        </span>
                                    </label>

                                    <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                        <select
                                            className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input"
                                            value={selectedProvince}
                                            onChange={(e) => {
                                                setSelectedProvince(e.target.value);
                                                // setSelectedDistrict("");
                                                setSelectedWard("");
                                            }}
                                            aria-invalid="false"
                                            id="92"
                                            required
                                        >
                                            <option value="">Tỉnh/Thành phố</option>
                                            {provinces.map(p => (
                                                <option key={p.code} value={p.name}>{p.name}</option>
                                            ))}
                                        </select>

                                        <svg
                                            className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled"
                                            focusable="false"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path d="M7 10l5 5 5-5z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* <div className="MuiFormControl-root MuiTextField-root jss22">
                                    <label
                                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                        data-shrink="true"
                                        htmlFor="917"
                                        id="917-label"
                                    >
                                        Quận/Huyện
                                        <span
                                            aria-hidden="true"
                                            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                        >
                                            &thinsp;*
                                        </span>
                                    </label>

                                    <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                        <select
                                            className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input"
                                            aria-invalid="false"
                                            value={selectedDistrict}
                                            onChange={(e) => {
                                                setSelectedDistrict(e.target.value);
                                                setSelectedWard("");
                                            }}
                                            id="917"
                                            required
                                        >
                                            <option value="">Quận/Huyện</option>
                                            {districts.map(d => (
                                                <option key={d.id} value={d.name}>{d.name}</option>
                                            ))}
                                        </select>

                                        <svg
                                            className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled"
                                            focusable="false"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path d="M7 10l5 5 5-5z" />
                                        </svg>
                                    </div>
                                </div> */}

                                <div className="MuiFormControl-root MuiTextField-root jss22">
                                    <label
                                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                        data-shrink="true"
                                        htmlFor="31162"
                                        id="31162-label"
                                    >
                                        Phường/Xã
                                        <span
                                            aria-hidden="true"
                                            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                        >
                                            &thinsp;*
                                        </span>
                                    </label>

                                    <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                        <select
                                            className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input"
                                            aria-invalid="false"
                                            id="31162"
                                            value={selectedWard}
                                            onChange={(e) => setSelectedWard(e.target.value)}
                                            required
                                        >
                                            <option value="">Phường/Xã</option>
                                            {wards.map(w => (
                                                <option key={w.code} value={w.name}>{w.name}</option>
                                            ))}
                                        </select>

                                        <svg
                                            className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled"
                                            focusable="false"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path d="M7 10l5 5 5-5z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div className="MuiFormControl-root MuiTextField-root jss22">
                                <label
                                    className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                    data-shrink="true"
                                    htmlFor="address"
                                    id="address-label"
                                >
                                    Số nhà - Tên đường
                                    <span
                                        aria-hidden="true"
                                        className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                    >
                                        &thinsp;*
                                    </span>
                                </label>

                                <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                    <input
                                        aria-invalid="false"
                                        id="address"
                                        required
                                        type="text"
                                        className="MuiInputBase-input MuiFilledInput-input"
                                        value={businessAddress}
                                        onChange={(e) => setBusinessAddress(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="MuiBox-root css-0"
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                    }}
                >
                    <button
                        className={`MuiButtonBase-root iQEreR MuiButton-root MuiButton-text sc-2362e412-0 bzqdaj my-order__button my-order__button--green bg-gradient ${!loading ? "" : "Mui-disabled Mui-disabled"
                            }`}
                        type="button"
                        disabled={loading}
                        onClick={handleConfirm}
                    >
                        <span className="MuiButton-label">{loading ? "Đang xử lý..." : "Xác nhận"}</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
